import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpRequest, HttpHandler, HttpResponse } from '@angular/common/http';
import { NEVER, Observable, catchError, finalize, map, switchMap, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { AuthService } from '../services/auth.service';

@Injectable()
export class Interceptor implements HttpInterceptor {

    constructor(private auth: AuthService) { }

    intercept(httpRequest: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // DO NOT REMOVE, THIS CHECKS FOR AUTHENTICATION OF USER
        if (
          (httpRequest.url.startsWith(environment.APICOMMON_URL) || 
          httpRequest.url.startsWith(environment.SUPPLIERONBOARDING_API_URL)) &&
          !httpRequest.url.includes('AuthToken')
        ) {
          const auth = sessionStorage.getItem('auth');
          if (auth ? this.checkTokenExpired(auth) : true) {
            this.auth.logout();
            return NEVER;
          } else if (auth && !this.checkTokenExpired(auth)) {
            return next
              .handle(
                httpRequest.clone({
                  setHeaders: { Authorization: 'Bearer ' + auth },
                })
              )
              .pipe(
                map((event: any) => {
                  if (event instanceof HttpResponse) {
                    // sessionStorage.setItem('auth', event.headers.get('authorization-token') ?? auth);
                  }
                  return event;
                }),
                finalize(() => {})
              );
          }
        }
        return next.handle(httpRequest);
    }

    checkTokenExpired(token: string) {
        const expiry = (JSON.parse(atob(token.split('.')[1]))).exp;
        return (Math.floor((new Date).getTime() / 1000)) >= expiry;
    }
}
